<p-toast position="top-right"></p-toast>
<div class="app-designation-management-respnsive p-g">
    <div class="p-g-12">
        <div class="card card-w-title p-table-tecfolk-fix">
            <h1 class="main-Heading">{{setLabel("designationManagementLabel")}}</h1>
            <p-table [value]="allDesignationManagement" [paginator]="true" [rows]="10">
                <!-- <ng-template pTemplate="caption"> -->
                <!-- <div class="ui-table-globalfilter-container"> -->

                <!-- <input pinputtext="" [(ngModel)]="designationSearch" autocomplete="off" placeholder="Search"
                                            type="text" name="searchValue" (keyup)="searchLocal(designationSearch, 'name')"
                                            style="color: #ffffff;" class="ui-inputtext ui-corner-all ui-state-default ui-widget" />
                                        &nbsp;&nbsp;
                                        <button style="
                                                background: #ffffff;
                                                color: #0e2031;
                                            " (click)="resetFilter()"
                                            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
                                            Clear</button>&nbsp; -->
                <!-- <button style="
                                                background: #ffffff;
                                                color: #0e2031;
                                                margin-top: 10px;
                                            " routerLink="booking-slot"
                                            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
                                            Add New</button>&nbsp;
                                          <button style="
                                            position: absolute;
                                            right: 21px;
                                            background: #ffffff;
                                            color: #0e2031;
                                            margin-top: 10px;
                                         " (click)="resetorClearSlots()"
                                            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
                                            Clear Slots</button>&nbsp; -->
                <!-- <button style="background: #ffffff; color: #0e2031;margin-top: 10px;" (click)="printAllInvoice()"
                                            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i class="fa fa-print"
                                            aria-hidden="true"></i> Print</button> -->

                <!-- <button (click)="updateAllDesignation()" id="updateDesignation" pButton type="button"
                                            label="Update Designation" icon="pi pi-money-bill  " class="ui-button-success"
                                            style="float: right;"></button> -->
                <!-- </div>
                                </ng-template> -->

                <ng-template pTemplate="caption" style="text-align: left">
                    <div class="reportMainFilter" style="width: 100% !important;">
                        <div class="reportMainFields">
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("searchByMembershipIDLabel")}}</span>
                                <input id="searchEmployee" #searchEmployee
                                    (keyup)="searchLocal(designationSearch, 'name')" [(ngModel)]="designationSearch"
                                    autocomplete="off" pinputtext="" [placeholder]='setLabel("searchByDesignationPlaceholderLabel")' type="text"
                                    name="name" class="p-inputtext p-corner-all p-state-default p-widget">
                            </div>
                            <div class="reportMainBtn">

                                <span [pTooltip]='setLabel("clearSearchTooltipLabel")' [disabled]="loading" (click)="resetFilter()"> <i
                                        class="pi pi-times"></i></span>
                            </div>
                        </div>
                        <div class="reportMainBtn">
                            <span [pTooltip]='setLabel("clearSearchTooltipLabel")' class="iconClear hideOnLaptop" [disabled]="loading" (click)="resetFilter()"> <i
                                class="pi pi-times"></i></span>

                            <!-- <button (click)="resetFilter()"
                                class="clear-Button ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
                                <i class="fa fa-eraser"></i>&nbsp;Clear Search</button> -->
                                <span
                                 [pTooltip]='setLabel("updateDesignationTooltipLabel")' [disabled]="loading" [disabled]="!isData"
                                (click)="updateAllDesignation()"><i class="fa fa-print"></i></span>

                            <!-- <button pButton type="button" class="update-Button p-button-success"
                                (click)="updateAllDesignation()" id="updateDesignation"><i
                                    class="fa fa-save"></i>Update Designation
                            </button> -->
                        </div>
                    </div>





                    <!-- <div>
                        <input id="searchEmployee" #searchEmployee (keyup)="searchLocal(designationSearch, 'name')"
                            [(ngModel)]="designationSearch" autocomplete="off" pinputtext=""
                            placeholder="Search By Designation" type="text" name="name"
                            class="input ng-pristine ng-valid ng-touched">
                    </div>
                    <div class="button-Main-Div">
                        <button (click)="resetFilter()"
                            class="clear-Button ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
                            <i class="fa fa-eraser"></i>&nbsp;Clear Search</button>

                        <button pButton type="button" class="update-Button p-button-success"
                            (click)="updateAllDesignation()" id="updateDesignation"><i
                                class="fa fa-save"></i>&nbsp;&nbsp;Update Designation
                        </button>
                    </div> -->

                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th>{{setLabel("designationLabel")}}</th>
                        <th>{{setLabel("salaryLabel")}}</th>
                        <th>{{setLabel("isActiveLabel")}}</th>
                        <th>{{setLabel("currencyLabel")}}</th>
                        <th>{{setLabel("actionsLabel")}}</th>
                    </tr>
                    <tr class="AddNewDesignationManagement">
                        <td>
                            <div class="mobile-Lable">{{setLabel("designationLabel")}}</div>
                            <input type="text" [placeholder]='setLabel(designationPlaceholderLabel)' name="Name"
                                [(ngModel)]="designationManagement.name" id="designationName" #designationName />
                        </td>
                        <td>
                            <div class="mobile-Lable">{{setLabel("salaryLabel")}}</div>

                            <input type="number" [placeholder]='setLabel("salaryPlaceholderLabel")' name="Salary"
                                [(ngModel)]="designationManagement.salary" id="designationSalary" #designationSalary />
                        </td>
                        <td>
                            <div class="mobile-Lable">{{setLabel("isActiveLabel")}}</div>

                            <p-inputSwitch name="Is_Active" [(ngModel)]="designationManagement.isActive"
                                id="designationIs_Active" #designationIs_Active></p-inputSwitch>
                        </td>
                        <td>
                            <div class="mobile-Lable">{{setLabel("actionsLabel")}}</div>

                            <p-dropdown [options]="currencyDropDown" name="Currency" id="designationCurrency"
                                #designationCurrency [style]="{'width':'70%'}"
                                [(ngModel)]="designationManagement.currency"></p-dropdown>
                        </td>
                        <td>
                            <!-- <button pButton type="button" pTooltip="Add Designation" label="Add New" icon="pi pi-plus" class="p-button-primary" style="background-color: #3f51b5"
                           (click)="addDesignation()" id="designationAdded" #designationAdded
                            ></button> -->
                            <button style="
                            background: #0E2031; color: white; width:100%"
                                class="p-button p-widget p-state-default p-corner-all"><span class="p-button-text p-c"
                                    (click)="addDesignation()"><i class="fa fa-plus"
                                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("addNewBtnLabel")}}</span></button>&nbsp;&nbsp;
                            <!-- &nbsp;&nbsp;&nbsp; <button pButton type="button" pTooltip="Clear" icon="fa fa-times"
                                (click)="clearFields()" id="designationClear" #designationClear></button> -->
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-allDesignationManagement>
                    <tr class="AddNewDesignationManagement">
                        <td>
                            <div class="mobile-Lable">{{setLabel("designationLabel")}}</div>
                            <input type="text" [placeholder]='setLabel("namePlaceholderLabel")' name="dataName"
                                [(ngModel)]="allDesignationManagement.name" />
                        </td>
                        <td>
                            <div class="mobile-Lable">{{setLabel("salaryLabel")}}</div>

                            <input type="number" [placeholder]='setLabel("salaryPlaceholderLabel")' name="dataSalary"
                                [(ngModel)]="allDesignationManagement.salary" />
                        </td>
                        <td>
                            <div class="mobile-Lable">{{setLabel("isActiveLabel")}}</div>

                            <p-inputSwitch name="dataIs_Active" [(ngModel)]="allDesignationManagement.isActive">
                            </p-inputSwitch>
                        </td>
                        <td>
                            <div class="mobile-Lable">{{setLabel("currencyLabel")}}</div>

                            <p-dropdown [options]="currencyDropDown" name="dataCurrency" [style]="{'width':'70%'}"
                                [(ngModel)]="allDesignationManagement.currency"></p-dropdown>
                        </td>
                        <td>
                            <!-- <button pButton type="button" pTooltip="Remove Designation"
                                (click)="deleteDesignation(allDesignationManagement._id)"
                                class="ui-button-danger ui-button" icon="fa fa-times"></button> -->
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>